<template>
    <section class="plugin-home-hero">
        <div class="plugin-home-hero__wrap" v-bind:style="backgroundStyle">
            <div class="plugin-home-hero__container">
                <div class="plugin-home-hero__container-content">
                    <h1 class="plugin-home-hero__header"
                        v-if="title !== null"
                    >
                        <span class="plugin-home-hero__header-title" v-text="title" />
                    </h1>

                    <div class="plugin-home-hero__description"
                         v-if="description !== null"
                         v-text="description"
                    />

                    <div class="plugin-home-hero__button"
                         v-if="buttonHref !== null && buttonText !== null"
                    >
                        <a class="plugin-home-hero__button-link"
                           v-bind:href="buttonHref"
                        >
                            <ui-button
                                theme="secondary-2"
                                size="huge"
                                v-bind:is-uppercase="false"
                            >
                                {{ buttonText }}
                            </ui-button>
                        </a>
                        <a class="plugin-home-hero__button-mobile-link"
                           v-bind:href="buttonHref"
                        >
                            <ui-button
                                theme="secondary-2"
                                size="lg"
                                v-bind:is-uppercase="false"
                            >
                                {{ buttonText }}
                            </ui-button>
                        </a>
                    </div>

                    <a class="plugin-home-hero__bank"
                       v-bind:href="bankHref"
                    >
                        <div class="plugin-home-hero__bank-icon">
                            <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.9973 0C31.0464 0 40 8.95542 40 19.9992C40 31.045 31.0464 40 19.9973 40C8.95362 40 0 31.0446 0 19.9992C0 8.95542 8.95362 0 19.9973 0ZM19.9973 1.54542C9.80454 1.54542 1.54539 9.80625 1.54539 19.9996C1.54539 30.1921 9.80454 38.4546 19.9973 38.4546C30.1926 38.4546 38.4534 30.1921 38.4534 19.9992C38.4534 9.80625 30.1926 1.54542 19.9973 1.54542ZM21.2726 5.63042C21.2726 5.63042 21.7328 6.46875 23.8791 6.08625C25.6542 5.76875 26.6366 6.23208 26.6366 6.82583C26.6366 6.82583 27.8994 6.97708 28.4624 7.3425C29.0271 7.70792 28.4287 8.62083 28.4287 8.62083C28.3426 8.45292 28.2227 8.35417 27.8811 8.27917C27.8811 8.27917 26.5163 7.92792 26.0411 8.81708C25.0038 8.90583 24.1075 9.52708 23.686 10.3721C23.6631 10.4217 23.2683 11.2033 23.5138 12.7813C23.6419 13.6096 24.0513 14.3121 24.6326 14.9104C24.8865 15.1729 25.2027 15.3408 25.5868 15.2971C26.1934 15.2267 26.6973 14.9358 27.1305 14.5071C27.3677 14.2712 27.4409 14.0029 27.2586 13.6942C27.2349 13.6533 27.2208 13.6067 27.2037 13.56C26.6674 12.2617 27.1163 11.1129 28.0276 10.4329C28.6979 9.93458 29.4715 9.87542 30.2575 9.98708C35.4404 10.7179 35.6139 15.9604 35.6139 17.5775V18.0092C35.6181 22.355 35.6846 25.4171 35.7171 26.0221C35.7691 26.9704 36.0995 27.1696 36.3096 27.3192C35.9797 27.5479 33.2813 26.6983 32.6338 25.8925C32.5901 25.8387 32.5011 25.8162 32.4332 25.7979C30.8263 25.4237 30.8229 23.7433 30.7922 23.2337C29.4473 23.2337 28.9268 21.7646 28.7841 21.3821C28.6618 21.0393 28.5804 20.6832 28.5415 20.3213C28.5415 21.0367 27.4846 21.6504 26.347 20.51C26.347 21.6829 24.9514 21.4754 24.2573 20.7808C24.1966 21.0183 23.8113 21.6225 23.8113 21.6225C24.6085 21.7675 24.9672 21.9425 25.3438 22.2725C26.2271 23.0487 26.3274 24.3442 26.3274 25.0133C26.3274 25.0133 27.5437 26.2013 28.0251 26.6417C28.1674 26.7746 28.3243 26.89 28.4807 27.0083C29.7282 25.6117 30.143 26.1562 30.1418 26.1604C31.0647 25.7879 31.5752 26.4471 31.3734 26.7829C31.1579 26.5387 30.8092 26.6108 30.5991 26.7996C31.8449 27.01 31.554 27.9246 31.2182 28.1162C31.2182 27.8537 31.1367 27.5621 30.7439 27.535C30.7639 27.9387 30.4917 28.0092 30.2333 28.0192C29.6154 28.0458 28.5839 28.0742 28.2693 28.3817C28.0883 28.5567 28.1761 29.0704 27.9827 29.2454C27.8216 29.3892 27.651 29.3725 27.5607 29.3738C27.5312 29.5629 27.5874 29.7758 27.8274 30.0271C26.9299 30.1004 26.2583 29.3104 26.7027 28.8883C26.8891 28.7121 27.5154 28.1175 27.5478 27.8583C27.589 27.5833 27.2982 27.2738 27.0964 27.0946C26.8357 26.8652 26.5673 26.6448 26.2916 26.4338L25.7403 26.0079C25.5993 25.9016 25.4503 25.8063 25.2947 25.7229C25.2254 25.6848 25.1493 25.6608 25.0707 25.6524C24.9922 25.6439 24.9127 25.6512 24.8369 25.6737C24.4928 25.7808 24.497 25.7725 24.4084 25.7133C24.0697 25.4904 23.4572 24.9879 22.1831 24.8467C22.2675 24.9004 22.327 24.9567 22.3761 25.0229C22.444 25.1187 22.4935 25.2333 22.5655 25.3887C22.6487 25.565 22.7119 25.7458 22.7868 25.9221C23.6107 27.8721 24.4263 29.7871 25.248 31.7375C25.5202 32.3825 25.2772 32.9471 24.6131 33.2575C24.1287 33.4833 23.577 33.3617 23.2524 32.8933C23.3456 33.215 23.3898 33.4933 23.2583 33.7612C23.1284 34.0292 22.9183 34.2212 22.6429 34.3383C22.3778 34.4554 22.0645 34.4967 21.7753 34.4383C21.4799 34.3792 21.2843 34.1842 21.1332 33.8979C21.1074 34.5346 20.6884 35 19.9973 35C19.3057 35 18.8863 34.5346 18.8613 33.8979C18.7103 34.1846 18.5139 34.3792 18.2189 34.4383C17.9263 34.4934 17.6238 34.4586 17.3513 34.3383C17.0759 34.2212 16.8657 34.0292 16.7359 33.7612C16.6048 33.4929 16.6485 33.2162 16.7417 32.8933C16.4172 33.3617 15.8654 33.4833 15.3811 33.2575C14.7166 32.9471 14.474 32.3825 14.7461 31.7375C15.5675 29.7875 16.3831 27.8721 17.2074 25.9221C17.2822 25.7458 17.3455 25.565 17.4287 25.3887C17.5007 25.2321 17.549 25.1179 17.6164 25.0229C17.6659 24.9567 17.725 24.9004 17.8111 24.8467C16.537 24.9863 15.9233 25.4904 15.5858 25.7133C15.4972 25.7725 15.5013 25.7808 15.1572 25.6737C15.0815 25.6511 15.002 25.6438 14.9234 25.6523C14.8449 25.6607 14.7688 25.6847 14.6995 25.7229C14.5456 25.8079 14.3879 25.9021 14.2539 26.0079C13.7953 26.365 13.3293 26.7108 12.8974 27.0946C12.696 27.2738 12.4052 27.5829 12.4464 27.8583C12.4771 28.1167 13.105 28.7121 13.291 28.8883C13.7363 29.3104 13.0643 30.1021 12.1667 30.0271C12.4068 29.7758 12.4617 29.5629 12.4322 29.3738C12.3432 29.3725 12.1726 29.3892 12.0115 29.2454C11.8168 29.0704 11.9042 28.5567 11.7253 28.3817C11.409 28.0742 10.3771 28.0458 9.76085 28.0192C9.50287 28.0092 9.23032 27.9387 9.24988 27.535C8.85625 27.5604 8.77552 27.8525 8.77552 28.1162C8.43848 27.9246 8.1493 27.0087 9.39551 26.7996C9.18497 26.6108 8.83503 26.5387 8.62074 26.7829C8.41893 26.4471 8.92948 25.7879 9.85239 26.1604C9.84948 26.1562 10.266 25.6129 11.5135 27.0087C11.6699 26.89 11.8268 26.7746 11.9691 26.6421C12.4505 26.2029 13.6668 25.0129 13.6668 25.0129C13.6668 24.3458 13.7666 23.0504 14.6488 22.2729C15.0274 21.9425 15.3853 21.7675 16.1829 21.6221C16.1829 21.6221 15.7976 21.0179 15.7369 20.7812C15.0428 21.4771 13.6472 21.6829 13.6472 20.5104C12.5096 21.6492 11.4527 21.0367 11.4527 20.3213C11.4138 20.6832 11.3324 21.0393 11.2101 21.3821C11.0674 21.7646 10.5469 23.2337 9.20203 23.2337C9.17082 23.7433 9.16791 25.4225 7.56093 25.7979C7.49311 25.8146 7.40407 25.8387 7.36037 25.8925C6.71126 26.6996 4.01494 27.5479 3.68289 27.3192C3.89344 27.1679 4.22382 26.9704 4.27583 26.0221C4.30954 25.3971 4.37861 22.1512 4.37861 17.5775L4.37902 17.4708C4.38818 15.7417 4.6628 10.7025 9.73671 9.98708C10.5231 9.87542 11.2963 9.93458 11.9662 10.4329C12.8778 11.1129 13.3268 12.2621 12.7905 13.56C12.7738 13.6067 12.7593 13.6533 12.7355 13.6942C12.5533 14.0033 12.6269 14.2713 12.8637 14.5067C13.2969 14.9358 13.8008 15.2267 14.4074 15.2971C14.7915 15.3408 15.1077 15.1729 15.3615 14.9104C15.9428 14.3121 16.3381 13.6079 16.4808 12.7813C16.7501 11.2104 16.331 10.4217 16.3086 10.3721C15.8867 9.52708 14.9904 8.90583 13.9535 8.81708C13.4779 7.92792 12.1131 8.27958 12.1131 8.27958C11.7719 8.35458 11.6516 8.45292 11.5638 8.62125C11.5638 8.62125 10.9671 7.70792 11.5305 7.34208C12.0947 6.97708 13.3576 6.82583 13.3576 6.82583C13.3576 6.23167 14.3396 5.76875 16.1138 6.08625C18.2601 6.46875 18.7215 5.63042 18.7215 5.63042C18.8102 6.65792 18.0258 7.18708 17.7745 7.33125C18.5888 8.21458 19.726 9.98 19.9973 12.4846C20.2678 9.98 21.4054 8.21458 22.2193 7.33125C21.9671 7.18708 21.184 6.65792 21.2726 5.63042Z" fill="currentColor"/>
                            </svg>
                        </div>
                        <div class="plugin-home-hero__bank-text">
                            Платформа в реестре ЦБ РФ
                        </div>
                    </a>
                </div>

                <div class="plugin-home-hero__footer">
                    <slot />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import config from '~/config';
import utils from '~/utils';

export default {
    name: 'plugin-home-hero-v2',
    props: {
        image: {
            type: String,
            default: null,
        },
        mobileImage: {
            type: String,
            default: null,
        },
        wideImage: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        subtitle: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: null,
        },
        buttonHref: {
            type: String,
            default: null,
        },
        buttonText: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        bankHref: config.urls.footer.register,
    }),
    computed: {
        backgroundStyle() {
            // TODO remove
            // const resize = utils.common.getResize();
            // return { backgroundImage: `url(${utils.common.injectResize(this.image, resize)})` };
            let background = null;
            if (this.isSmallScreen && this.mobileImage) {
                background = `linear-gradient(0deg,rgba(0, 0, 0, 1) 10%, rgba(255, 255, 255, 0) 40%), url(${utils.common.injectResize(this.mobileImage, '1024xAUTO')})`;
            } else if (this.isMediumScreen && this.image) {
                background = `linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.85)), url(${utils.common.injectResize(this.image, '1920xAUTO')})`;
            } else if (this.isWideScreen && this.wideImage) {
                background = `linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.85)), url(${utils.common.injectResize(this.wideImage, '2560xAUTO')})`;
            } else if (this.image) {
                background = `linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.85)), url(${utils.common.injectResize(this.image, '2560xAUTO')})`;
            }
            if (background) {
                return {
                    backgroundImage: background,
                };
            }
            return null;
        },
        isSmallScreen() {
            return window.innerWidth < 768;
        },
        isMediumScreen() {
            return window.innerWidth >= 768 && window.innerWidth <= 1440;
        },
        isWideScreen() {
            return window.innerWidth > 1440;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-hero {
    // width: 100%;

    padding-bottom: 40px;

    color: @color-gray-lightest;
    &__wrap {
        width: 100%;
        min-height: 100vh;
        border-radius: 0 0 54px 54px;
        background-size: cover;
        background-position-y: top;
        background-position-x: center;
        background-repeat: no-repeat;
        background-color: @color-gray-main;
    }

    &__container {
        .container-landing-hero();

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 88px;

        // min-height: calc(100vh - @container-header-height - 40px);
        min-height: 100vh;

        padding-top: 144px;
        // padding-right: @landing-padding;
        padding-bottom: 84px;
        // padding-left: @landing-padding;

        // border-radius: 0 0 54px 54px;

        // background-color: @color-gray-main;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;

        &-content {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 24px;
        }
    }
    &__header {
        max-width: 846px;
        margin: 0;
        &-title {
            font-size: 6.4rem;
            font-weight: 700;
            line-height: 6.8rem;
        }
    }
    &__description {
        .typography-large();

        max-width: 825px;
    }
    &__button {
        display: flex;
        justify-content: flex-start;
        &-link {
            display: block;
            text-decoration: none;
        }
        &-mobile-link {
            display: none;
        }
    }
    &__bank {
        flex: 0 1 auto;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 12px;
        text-decoration: none;
        &-icon {
            flex: 0 0 auto;
            overflow: hidden;
        }
        &-text {
            .typography-large();

            flex: 1 1 auto;
        }
    }
    &__footer {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        // gap: 12px;
        > * {
            padding: 12px 6px;
        }
        > *:not(:last-child) {
            border-right: 1px solid @color-gray-main;
        }
    }

    @media (min-width: 2000px) {
        &__container {
            padding-top: 280px;
            &-content {
                gap: 64px;
            }
        }
        &__header {
            max-width: 1250px;
            &-title {
                font-size: 7.2rem;
                font-weight: 700;
                line-height: 7.2rem;
            }
        }
        &__description {
            max-width: 1400px;
            font-size: 4.8rem;
            line-height: 5.4rem;
        }
    }
    @media @media-lg-down {
        &__container {
            &-content {
                align-items: center;
            }
        }
        &__header {
            text-align: center;
        }
        &__description {
            text-align: center;
        }
        &__footer {
            grid-template-columns: repeat(2, 1fr);
            // gap: 24px;
            > *:not(:last-child) {
                border-right: 0;
            }
        }
    }
    @media @media-md-down {
        padding: 0;

        &__container {
            &-content {
                gap: 16px;
            }

            padding-top: 102px;
            padding-bottom: 90px;
        }
        &__bank {
            &-icon {
                svg {
                    width: 32px;
                    height: 32px;
                }
            }
            &-text {
                .typography-heading();
            }
        }
        &__header {
            &-title {
                .typography-large();
            }
        }
        &__description {
            .typography-heading();
        }
        &__button {
            &-link {
                width: 100%;
                max-width: 320px;
            }
        }
    }
    @media @media-sm-down {
        &__container {
            // padding-left: @landing-padding-mobile;
            // padding-right: @landing-padding-mobile;
            padding-bottom: 12px;
            &-content {
                gap: 12px;
            }
        }
        &__button {
            font-weight: bold;
            width: 100%;
            &-link {
                display: none;
            }
            &-mobile-link {
                text-decoration: none;
                display: block;
                width: 100%;
            }
        }
        &__bank {
            // padding-top: 16px;
            &-icon {
                svg {
                    width: 24px;
                    height: 24px;
                }
            }
            &-text {
                .typography-body();
            }
        }
        &__description {
            .typography-body();
        }
        &__footer {
            // gap: 12px;
        }
    }
}
</style>
